import { ca } from '@cian/analytics';

export function trackTransferToDeveloperCard(developerCardLink?: string | null) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Card_JK',
    action: 'to_developerCard',
    label: developerCardLink,
    useLastProducts: true,
  });
}
